<template>
	<div>
		<van-nav-bar :title="title" class="nav-bar" left-arrow @click-left="back()">
		</van-nav-bar>

		<div class="container">
			<van-sidebar v-model="activeKey">
				<van-sidebar-item :title="item.type_name" v-for="(item, index) in list" :key="index"
					@click="sidebarS(item)" />
			</van-sidebar>
			<div class="content">
				<div v-for="(item, index) in listS" :key="index" class="contentA"
					@click="$router.push({ path: '/Chooses', query: { id: item.id } })">
					<van-image radius='10' width="100%" height="100" :src="item.image" fit="cover" />
					<div style="padding-top: 6px;font-size: 16px;">{{ item.name }}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeKey: 0,
			list: [],
			listS: [],
			title: '',
		};
	},
	created() {
		this.LotteryTypeList()
		this.title = this.$route.query.title || ''
	},
	computed: {},
	methods: {
		back() {
			this.$router.back()
		},
		//投票
		LotteryTypeList() {
			this.$http({
				method: "get",
				url: "LotteryTypeList",
			}).then((res) => {
				if (res.code == 1) {
					this.list = res.data;
					this.sidebarS(res.data[0].id)
				} else {
					this.$toast(res.msg);
				}
			});
		},
		sidebarS(index) {
			console.log(index)
			console.log(this.activeKey)
			this.$http({
				method: "get",
				url: "LotteryList",
				data: {
					lottery_type_id: index.id,
				},
			}).then((res) => {
				if (res.code == 1) {
					console.log(res.data)
					this.listS = res.data;
				} else {
					this.$toast(res.msg);
				}
			});
		}

	},
};
</script>

<style lang="less" scoped>
.nav-bar {
	background: linear-gradient(90deg, #f905e5, #e6c3a1);

	/deep/.van-icon {
		color: #fff !important;
	}
}

.container {
	display: flex;
	flex-direction: row;
	background-color: #f2f2f5;

	.content {
		width: calc(100% - 200px);
		height: calc(100vh - 105px);
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
		align-content: flex-start;
		padding: 20px;
		overflow-y: auto;
		scrollbar-width: none;
		-ms-overflow-style: none;

		.contentA {
			width: 240px;
			height: 260px;
			background-color: #fff;
			padding: 20px;
			border-radius: 20px;
			margin-bottom: 20px;
			text-align: center;
		}
	}

	.van-sidebar {
		height: calc(100vh - 105px);
		background-color: #fff;
		width: 200px;

		.van-sidebar-item {
			font-size: 30px;
			line-height: 50px !important;
			padding: 30px;
			background-color: #fff;
			text-align: center;
		}

		.van-sidebar-item--select {
			background-color: #f2f2f5;
			color: #f905e5;
			text-align: center;
		}

		.van-sidebar-item--select::before {
			width: 6px;
			height: 60px;
			margin-left: 10px;
			border-radius: 10px;
			background-color: #f905e5;
		}
	}
}
</style>